import { render } from "./WaveComponent.vue?vue&type=template&id=2bc9506c&scoped=true"
import script from "./WaveComponent.vue?vue&type=script&lang=js"
export * from "./WaveComponent.vue?vue&type=script&lang=js"

import "./WaveComponent.vue?vue&type=style&index=0&id=2bc9506c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc9506c"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QDialog,QLayout});
